/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum Antenna {
    A = 'a',
    B = 'b'
}


export function instanceOfAntenna(value: any): boolean {
    for (const key in Antenna) {
        if (Object.prototype.hasOwnProperty.call(Antenna, key)) {
            if (Antenna[key as keyof typeof Antenna] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AntennaFromJSON(json: any): Antenna {
    return AntennaFromJSONTyped(json, false);
}

export function AntennaFromJSONTyped(json: any, ignoreDiscriminator: boolean): Antenna {
    return json as Antenna;
}

export function AntennaToJSON(value?: Antenna | null): any {
    return value as any;
}

export function AntennaToJSONTyped(value: any, ignoreDiscriminator: boolean): Antenna {
    return value as Antenna;
}

